<template>
  <div class="loading-container">
    <font-awesome-icon icon="spinner"
                       class="icon"
                       aria-hidden="true"
                       :size="size"
                       spin></font-awesome-icon>
  </div>
</template>

<script>
export default {
  name: "LoadingSpinner",
  props: {
    size: {
      type: String,
      default: "3x",
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../Styles/utils/colors.less";

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  color: @color-primary;
  margin: 40px 0;

  > svg:first-child {
    margin-right: 0;
  }
}
</style>
